module.exports = __webpack_public_path__ + "static/media/cross-icon.6182d53b.svg";